// Action Types
export const FETCH_TRACKING_RECORDS_REQUEST = 'FETCH_TRACKING_RECORDS_REQUEST';
export const FETCH_TRACKING_RECORDS_SUCCESS = 'FETCH_TRACKING_RECORDS_SUCCESS';
export const FETCH_TRACKING_RECORDS_FAILURE = 'FETCH_TRACKING_RECORDS_FAILURE';

export const UPDATE_FILTERS = 'UPDATE_FILTERS';
export const UPDATE_PAGINATION = 'UPDATE_PAGINATION';

export const FETCH_TRACKING_STATS_REQUEST = 'FETCH_TRACKING_STATS_REQUEST';
export const FETCH_TRACKING_STATS_SUCCESS = 'FETCH_TRACKING_STATS_SUCCESS';
export const FETCH_TRACKING_STATS_FAILURE = 'FETCH_TRACKING_STATS_FAILURE';

export const RESET_ERROR = 'RESET_ERROR';

// Action Creators
export const fetchTrackingRecords = (filters, pagination) => ({
  type: FETCH_TRACKING_RECORDS_REQUEST,
  payload: { filters, pagination }
});

export const fetchTrackingRecordsSuccess = (records, pagination) => ({
  type: FETCH_TRACKING_RECORDS_SUCCESS,
  payload: { records, pagination }
});

export const fetchTrackingRecordsFailure = (error) => ({
  type: FETCH_TRACKING_RECORDS_FAILURE,
  payload: error
});

export const updateFilters = (filters) => ({
  type: UPDATE_FILTERS,
  payload: filters
});

export const updatePagination = (pagination) => ({
  type: UPDATE_PAGINATION,
  payload: pagination
});

export const fetchTrackingStats = (filters) => ({
  type: FETCH_TRACKING_STATS_REQUEST,
  payload: { filters }
});

export const fetchTrackingStatsSuccess = (statistics) => ({
  type: FETCH_TRACKING_STATS_SUCCESS,
  payload: statistics
});

export const fetchTrackingStatsFailure = (error) => ({
  type: FETCH_TRACKING_STATS_FAILURE,
  payload: error
});

export const resetError = () => ({
  type: RESET_ERROR
});